import { Button, InputAdornment, Modal, TextField } from '@mui/material';
import React, { useState } from 'react'
import Swal from 'sweetalert2';
import request from '../../../../Helpers/API';
import { LoaderScreen } from '../../../components/LoaderScreen';

export const CargarConvenioModal = ({ open, handleCloseModal, folio }) => {
    const [evidencia, setEvidencia] = useState({
        documento: "",
        extension: "",
    })
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const GetFile = ({ target }) => {
        const file = target.files[0].name.split(".");
        if (file.length > 2) {
            Swal.fire("Clientes", "Archivo invalido", "error");
            return;
        }

        if (
            file[1] !== "jpg" &&
            file[1] !== "jepg" &&
            file[1] !== "pdf" &&
            file[1] !== "PDF"
        ) {
            Swal.fire("Clientes", "Archivo con formato no valido", "error");
            target.value = "";
            return;
        }
        var fReader = new FileReader();
        fReader.readAsDataURL(target.files[0]);
        fReader.onloadend = function (event) {
            setEvidencia({
                ...evidencia,
                documento: event.target.result,
                extension: file[1],
            });
        };
    };

    const onGuardar = () => {
        const post = {
            documento: evidencia.documento,
            extension: evidencia.extension,
            folio,
        }

        request
            .post("DetalleClienteGestionarConvenios/CargarEvidencia", post)
            .then(async () => {
                setLoader({ ...loader, mostrar: false });
                handleCloseModal();

                await Swal.fire({
                    title: "CARGA DE EVICENCIA",
                    text: "Evidencia guardada con éxito",
                    icon: "success",
                    customClass: {
                        container: "mi-superpoop",
                    },
                });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("CARGA DE EVIDENCIA", JSON.stringify(error), "error");
            });
    };
    return (
        <Modal open={open}>
            <div className="dash-clientes-credito-crear-solicitud-modal">
                <LoaderScreen loader={loader} />
                <div className="credito-agregar-modal-title">
                    {/* <Agriculture
              color="primary"
              style={{ textAlign: "center", fontSize: 50 }}
            /> */}
                    <div className="filtro-soy-el-titulo-header">
                        <h3>CARGAR EVIDENCIA </h3>
                    </div>
                </div>
                <div className="modal-tasa-intereses-filtro-soy-el-titulo-line">
                    <div className="modal-tasa-intereses-filtro-soy-el-titulo-line-bl"></div>
                    <div className="modal-tasa-intereses-filtro-soy-el-titulo-line-circle"></div>
                    <div className="modal-tasa-intereses-filtro-soy-el-titulo-line-br"></div>
                </div>

                <div>
                    <div className="">

                        <TextField
                            id="clientes-documento"
                            type="file"
                            onChange={GetFile}
                            sx={{ mb: 2, width: 540 }}
                        />

                    </div>

                </div>

                <div className="credito-crear-tasa-interes-modal-button-container ">
                    <Button onClick={handleCloseModal} variant="contained" color="error">
                        Cerrar
                    </Button>
                    <Button variant="contained"
                        onClick={() => onGuardar()}
                    >
                        Agregar
                    </Button>
                </div>
            </div>
        </Modal>
    )
}
